import { ShareButton, type ShareButtonProps } from '../ShareButton/ShareButton';

interface ShareButtonContainerProps extends Omit<ShareButtonProps, 'onClick'> {
  url: string;
  title: string;
  text: string;
  onShareSuccess?: () => void;
  onShareError?: () => void;
}

export function ShareButtonContainer(props: ShareButtonContainerProps) {
  const { url, title, text, onShareSuccess, onShareError } = props;
  return (
    <ShareButton
      {...props}
      onClick={async () => {
        const data = {
          title,
          text,
          url: url,
        };

        try {
          await navigator.clipboard.writeText(props.url);
          onShareSuccess?.(); // Toast for "copied to clipboard"
        } catch {
          onShareError?.(); // Toast for "failed to copy to clipboard"
        }

        try {
          navigator.canShare(data) && (await navigator.share(data));
        } catch {}
      }}
    />
  );
}
